import { render, staticRenderFns } from "./RecipientForm.vue?vue&type=template&id=bf22e716&"
import script from "./RecipientForm.vue?vue&type=script&lang=js&"
export * from "./RecipientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports